export default __webpack_public_path__ + "images/HLF_Logotyp_vit_rod_bc6f2e1731e02bdc94cf725c43b1578f.svg";